import React from "react";
import { Typography } from "@mui/material";

import { SupportNumber, A } from "commons";
import {
    CLIENT_SELECTION_DISCLAIMER,
    READ_ONLY_PARAGRAPH,
    NAVIGATION_PARAGRAPH,
    PASSWORD_CHANGE,
    ADVISER_PLATFORM,
    changePasswordLink,
    QUESTIONS_DISCLAIMER,
    userGuideLink,
    ADVISER_GUIDE,
    CONTACT_US
} from "commons/src/constants/adviserViewConstants";

export function AdviserViewMessage() {
    return (
        <>
            <Typography paragraph>{CLIENT_SELECTION_DISCLAIMER}</Typography>
            <Typography paragraph>{READ_ONLY_PARAGRAPH}</Typography>
            <Typography paragraph>{NAVIGATION_PARAGRAPH}</Typography>
            <Typography paragraph>
                {PASSWORD_CHANGE}{" "}
                <A href={changePasswordLink} target="_blank">
                    {ADVISER_PLATFORM}
                </A>
            </Typography>
            <Typography paragraph>
                {QUESTIONS_DISCLAIMER}{" "}
                <A href={userGuideLink} target="_blank">
                    {ADVISER_GUIDE}
                </A>
                {CONTACT_US} <SupportNumber />.
            </Typography>
        </>
    );
}
